var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 45C63.9783 45 67.7936 46.5804 70.6066 49.3934C73.4197 52.2064 75 56.0218 75 60C75 63.9782 73.4197 67.7936 70.6066 70.6066C67.7936 73.4197 63.9783 75 60 75C56.0218 75 52.2065 73.4197 49.3934 70.6066C46.5804 67.7936 45 63.9782 45 60C45 56.0218 46.5804 52.2064 49.3934 49.3934C52.2065 46.5804 56.0218 45 60 45ZM60 22.5C85 22.5 106.35 38.05 115 60C106.35 81.95 85 97.5 60 97.5C35 97.5 13.65 81.95 5 60C13.65 38.05 35 22.5 60 22.5ZM15.9 60C19.9413 68.2515 26.2165 75.2037 34.0124 80.0663C41.8083 84.9288 50.812 87.5066 60 87.5066C69.188 87.5066 78.1918 84.9288 85.9876 80.0663C93.7835 75.2037 100.059 68.2515 104.1 60C100.059 51.7485 93.7835 44.7963 85.9876 39.9337C78.1918 35.0712 69.188 32.4934 60 32.4934C50.812 32.4934 41.8083 35.0712 34.0124 39.9337C26.2165 44.7963 19.9413 51.7485 15.9 60Z",
    fill: "url(#paint0_linear_1455_871)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 45C63.9783 45 67.7936 46.5804 70.6066 49.3934C73.4197 52.2064 75 56.0218 75 60C75 63.9782 73.4197 67.7936 70.6066 70.6066C67.7936 73.4197 63.9783 75 60 75C56.0218 75 52.2065 73.4197 49.3934 70.6066C46.5804 67.7936 45 63.9782 45 60C45 56.0218 46.5804 52.2064 49.3934 49.3934C52.2065 46.5804 56.0218 45 60 45ZM60 22.5C85 22.5 106.35 38.05 115 60C106.35 81.95 85 97.5 60 97.5C35 97.5 13.65 81.95 5 60C13.65 38.05 35 22.5 60 22.5ZM15.9 60C19.9413 68.2515 26.2165 75.2037 34.0124 80.0663C41.8083 84.9288 50.812 87.5066 60 87.5066C69.188 87.5066 78.1918 84.9288 85.9876 80.0663C93.7835 75.2037 100.059 68.2515 104.1 60C100.059 51.7485 93.7835 44.7963 85.9876 39.9337C78.1918 35.0712 69.188 32.4934 60 32.4934C50.812 32.4934 41.8083 35.0712 34.0124 39.9337C26.2165 44.7963 19.9413 51.7485 15.9 60Z",
    fill: "url(#paint1_linear_1455_871)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1455_871",
    x1: 60,
    y1: 22.5,
    x2: 60,
    y2: 97.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#74979F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E9772"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1455_871",
    x1: 60,
    y1: 22.5,
    x2: 60,
    y2: 97.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5188"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#74979F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E9772"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeColored);
export default __webpack_public_path__ + "static/media/eye-colored.3409c2eef5e05490a6ad5ca0b0f9d62e.svg";
export { ForwardRef as ReactComponent };